import React, { useState, useEffect, useRef } from "react"
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { PropTypes } from 'prop-types';
import { MapContainer, TileLayer, Marker, Popup, LayersControl } from 'react-leaflet';

import bl from "assets/icons/pin1.png";
import rd from "assets/icons/pin2.png";
import gn from "assets/icons/pin3.png";

const FMap = (props) => {

    const redPoint = L.icon({
      iconUrl:rd,
      iconSize: [26, 51], 
      iconAnchor: [14, 80], 
      popupAnchor: [-3, -76] 
    })
    const bluePoint = L.icon({
      iconUrl:bl,
      iconSize: [26, 51], 
      iconAnchor: [14, 80], 
      popupAnchor: [-3, -76] 
    })
    const greenPoint = L.icon({
      iconUrl:gn,
      iconSize: [26, 51], 
      iconAnchor: [14, 80], 
      popupAnchor: [-3, -76] 
    })
    return ( 
      <MapContainer center={[9.583397, 44.083651]} zoom={10} scrollWheelZoom={true} style={{ height: '800px', width: '100%' }}>
      <LayersControl position="topright">
          <LayersControl.BaseLayer name="Satellite">
            <TileLayer
              attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
              url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
              id="mapbox/satellite-v9" 
              accessToken={process.env.REACT_APP_APIKEY}
            />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer checked name="Street">
            <TileLayer
                attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                id="mapbox/streets-v11" 
                accessToken={process.env.REACT_APP_APIKEY}
              />
          </LayersControl.BaseLayer>
          </LayersControl>
          {props.points.map((p,k) => ( 
            <Marker key={k} position={[p.geometry.coordinates[1], p.geometry.coordinates[0]]} icon={(p.type == 'Borehole Stationx') ? bluePoint : redPoint}>
                  <Popup>
                  <p><strong>{p.area}<br/>{p.name}</strong><br/>{p.type}</p>
                  </Popup>
              </Marker>
          ))}
    </MapContainer>
  )
  }
FMap.propTypes = {
    points: PropTypes.array,
    pipes: PropTypes.any
}

  
export default FMap;
